import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import ContentBox from 'components/ContentBox'
import { FormControl, InputLabel, makeStyles, MenuItem, OutlinedInput as MuiOutlinedInput, Select, Typography, withStyles } from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { map, range } from 'lodash'
import { useSelector, useDispatch } from 'react-redux'
import { getEmpresaUsuario } from 'store/modules/auth/auth.selectors'
import { getAnoSelecionado } from 'store/modules/auditor/auditor.selectors'
import { callListarDadosAuditoria, changeAnoSelecionado } from 'store/modules/auditor'

const useStyles = makeStyles((theme) => ({
  contentBox: {
    padding: theme.spacing(2),
  },
  contentHeader: {
    display: 'flex',
    columnGap: '25px',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '48px',
  },

  title: {
    fontSize: 32,
    flexShrink: 0,
    color: theme.palette.common.white,
  },
  formControl: {
    height: 60,
    width: 260,
    marginLeft: theme.spacing(1),
    '& .MuiFormLabel-root': {
      color: theme.palette.white.main,
      fontSize: theme.typography.pxToRem(14),
    },
    '& .MuiInputBase-root:hover': {
      color: theme.palette.white.main,
    },
  },
  select: {
    color: theme.palette.white.main,
  },
  iconSelect: {
    color: theme.palette.white.main,
  },
}))

const OutlinedInput = withStyles((theme) => ({
  root: {
    '& $notchedOutline': {
      borderColor: theme.palette.white.main,
    },
    '&:hover $notchedOutline': {
      borderColor: theme.palette.white.main,
    },
    '&$focused $notchedOutline': {
      borderColor: theme.palette.white.main,
    },
  },
  focused: {},
  notchedOutline: {},
}))(MuiOutlinedInput)

const anoAtual = +moment().format('YYYY')
const anos = map(range(2014, anoAtual + 2), (ano) => ({
  value: ano.toString(), label: `${(ano - 1).toString()}/${ano.toString().slice(2)}`,
}))

const AuditorEmpresaLayout = ({ renderChildren, title }) => {
  const classes = useStyles()
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const empresa = useSelector(getEmpresaUsuario)
  const anoSelecionadoReducer = useSelector(getAnoSelecionado)

  const [anoSelecionado, setAnoSelecionado] = useState(anoSelecionadoReducer || anoAtual.toString())

  useEffect(() => {
    dispatch(callListarDadosAuditoria({
      empresaId: empresa.id, ano: anoSelecionado,
    }))
  }, [anoSelecionado, dispatch, empresa.id])

  const handleChangeAno = (event) => {
    setAnoSelecionado(event.target.value)
    dispatch(changeAnoSelecionado(event.target.value))
  }

  return (
    <>
      <div className={classes.contentHeader}>
        <Typography className={classes.title} variant="h1">{title}</Typography>
        <FormControl variant="outlined" className={classes.formControl}>
          <InputLabel htmlFor="ano-base">
            {t('pressaoBiodiversidade.selecioneAno')}
          </InputLabel>
          <Select
            classes={{
              select: classes.select,
              icon: classes.iconSelect,
            }}
            value={anoSelecionado}
            onChange={handleChangeAno}
            label={t('pressaoBiodiversidade.selecioneAno')}
            inputProps={{
              name: 'ano-base',
              id: 'ano-base',
            }}
            input={<OutlinedInput label={t('pressaoBiodiversidade.selecioneAno')} />}
          >
            {map(anos, (option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

      </div>
      <ContentBox className={classes.contentBox}>
        {renderChildren}
      </ContentBox>
    </>
  )
}

AuditorEmpresaLayout.propTypes = {
  title: PropTypes.string,
  renderChildren: PropTypes.object,
}

export default AuditorEmpresaLayout
